import React, { useState } from 'react'

export const LocalizacaoContext = React.createContext({})

export const LocalizacaoProvider = (props) => {

	const [localizacao, setarLocalizacao] = useState({
		lat: null,
		lng: null
	})

	return <LocalizacaoContext.Provider value={{ localizacao, setarLocalizacao }}>{props.children}</LocalizacaoContext.Provider>

}

export const useLocalizacao = () => React.useContext(LocalizacaoContext)
